import apiClient from './apiClient';

const API_URL = '/tramites/declaratoria';

// Listar / filtrar trámites de Declaratoria de Herederos
export const getTramitesDeclaratoria = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye herederos y checklist)
export const getTramiteDeclaratoriaById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Preview en vivo del checklist de documentación (siempre los mismos formularios)
export const previewChecklistDeclaratoria = async () => {
    const response = await apiClient.get(`${API_URL}/formularios`);
    return response.data;
};

// Crear un nuevo trámite de Declaratoria
export const crearTramiteDeclaratoria = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Declaratoria:', error.response?.data || error.message);
        throw error;
    }
};

// Editar datos del causante / preparación (no el cliente)
export const actualizarTramiteDeclaratoria = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Seguimiento judicial editable (carátula, expediente SAC, juzgado, observación del tribunal,
// corrección de fechas de hitos). Independiente del cambio de estado.
export const actualizarSeguimientoDeclaratoria = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/seguimiento`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable)
export const actualizarComentariosDeclaratoria = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Avanzar de estado: cada transición manda su propio mini-formulario (destino + dato de la etapa)
export const avanzarEstadoDeclaratoria = async (id, dto) => {
    const response = await apiClient.patch(`${API_URL}/${id}/estado`, dto);
    return response.data;
};

// ----------------- Herederos (CRUD) -----------------

export const getHerederosDeclaratoria = async (idTramite) => {
    const response = await apiClient.get(`${API_URL}/${idTramite}/herederos`);
    return response.data;
};

export const agregarHerederoDeclaratoria = async (idTramite, dto) => {
    const response = await apiClient.post(`${API_URL}/${idTramite}/herederos`, dto);
    return response.data;
};

export const editarHerederoDeclaratoria = async (idTramite, idHeredero, dto) => {
    const response = await apiClient.put(`${API_URL}/${idTramite}/herederos/${idHeredero}`, dto);
    return response.data;
};

export const eliminarHerederoDeclaratoria = async (idTramite, idHeredero) => {
    await apiClient.delete(`${API_URL}/${idTramite}/herederos/${idHeredero}`);
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistDeclaratoria = async (idItem, presentado, idArchivo) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

const declaratoriaService = {
    getTramitesDeclaratoria,
    getTramiteDeclaratoriaById,
    previewChecklistDeclaratoria,
    crearTramiteDeclaratoria,
    actualizarTramiteDeclaratoria,
    actualizarSeguimientoDeclaratoria,
    actualizarComentariosDeclaratoria,
    avanzarEstadoDeclaratoria,
    getHerederosDeclaratoria,
    agregarHerederoDeclaratoria,
    editarHerederoDeclaratoria,
    eliminarHerederoDeclaratoria,
    actualizarChecklistDeclaratoria,
};

export default declaratoriaService;
